import { render, staticRenderFns } from "./msgSetting.vue?vue&type=template&id=c3e5a9da&scoped=true&"
import script from "./msgSetting.vue?vue&type=script&lang=js&"
export * from "./msgSetting.vue?vue&type=script&lang=js&"
import style0 from "./msgSetting.vue?vue&type=style&index=0&id=c3e5a9da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e5a9da",
  null
  
)

component.options.__file = "msgSetting.vue"
export default component.exports